import { AxiosInstance } from "axios";

export function askQuestionBuilder(apiClient: AxiosInstance) {
  return async function askQuestion(payload: {
    course: number;
    media_url: string;
    selected_option: any;
    text: string;
  }): Promise<any> {
    const response = await apiClient.post(`/questions/`, payload);
    return response.data;
  };
}
